import { publishMessage } from "../notification/notificationActions";
import * as areaActionTypes from "./areaActionTypes";
import * as message from "../../message";
import { hideSpinner, showSpinner } from "../spinner/spinnerActions";
import Axios from "axios";
import { baseUrl } from "../../util/host";
import { setDeliveryList } from "../city/cityActions";

export const setAreaList = (areas) => {
  return {
    type: areaActionTypes.LOAD_AREA,
    value: areas,
  };
};

export const loadArea = (country, provinceId, cityId) => {
  const warehouse = localStorage.getItem("warehouse");
  const payload = { country: country, provinceId, cityId, warehouse };
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(`${baseUrl("REACT_APP_API_URL")}/api/address/find/area`, payload)
      .then((res) => {
        dispatch(setAreaList(res.data.response));
        dispatch(setDeliveryList(res.data.deliveryOption))
        dispatch(
          publishMessage({
            message: message.LOAD_AREA_SUCCESS,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};

export const updateArea = (area) => {
  const country = localStorage.getItem("country");
  const provinceId = localStorage.getItem("provinceId");
  const cityId = localStorage.getItem("cityId");
  const warehouse = localStorage.getItem("warehouse");
  area.holiday = Array.isArray(area.holiday) ? area.holiday.join(",") : area.holiday;
  const payload = { objkey: country, country, provinceId, cityId, area, warehouse };
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.put(`${baseUrl("REACT_APP_API_URL")}/api/address/area`, payload)
      .then((res) => {
        dispatch(loadArea(country, provinceId, cityId));
        dispatch(setDeliveryList(res.data.deliveryOption));
        dispatch(
          publishMessage({
            message: "Area Loaded",
            severity: "success",
          })
        );
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};

export const addNewArea = (area) => {
  const country = localStorage.getItem("country");
  const provinceId = localStorage.getItem("provinceId");
  const cityId = localStorage.getItem("cityId");
  const warehouse = localStorage.getItem("warehouse");
  area.holiday = Array.isArray(area.holiday) ? area.holiday.join(",") : area.holiday;
  const payload = { objkey: country, country, provinceId, cityId, area, warehouse };
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(`${baseUrl("REACT_APP_API_URL")}/api/address/area`, payload)
      .then((res) => {
        dispatch(loadArea(country, provinceId, cityId));
        dispatch(
          publishMessage({
            message: "Area Loaded",
            severity: "success",
          })
        );
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};
export const setDefaultArea = (area) => {
  const country = localStorage.getItem("country");
  const cityId = localStorage.getItem("cityId");
  const provinceId = localStorage.getItem("provinceId");
  const payload = { country, area, cityId, provinceId };
  
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(`${baseUrl("REACT_APP_API_URL")}/api/address/default/area`, payload)
      .then((res) => {
        // Success - reload the area list to show updated default status
        dispatch(loadArea(country, provinceId, cityId));
        
        // Show success notification
        dispatch(
          publishMessage({
            message: "Default area set successfully",
            severity: "success",
          })
        );
        
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.error("Error setting default area:", err);
        
        // Extract error message from response
        const errorMessage = err.response?.data?.statusMsg 
          || err.response?.data?.message 
          || "Failed to set default area. Please ensure the parent city is set as default first.";
        
        // Show error notification with the backend error message
        dispatch(
          publishMessage({
            message: errorMessage,
            severity: "error",
          })
        );
        
        dispatch(hideSpinner());
      });
  };
};